import get from 'lodash-es/get';
import includes from 'lodash-es/includes';
import { API } from '@/api/config';
import toArray from 'lodash-es/toArray';
import forEach from 'lodash-es/forEach';

/***
 * Класс для работы со сравнением
 */
class Compare {
  /***
   * Массив товаров в сравнении
   * @type {Object[]|null}
   */
  static compare = null;

  /***
   * Ссылка на API
   * @type {string}
   */
  static baseUrl = !PROD ?
    `${API.DEVELOP_USER}/compare` :
    SAND ?
      `${API.SAND_USER}/compare` :
      `${API.PROD_USER}/compare`;

  /***
   * Инициализация
   */
  static init = () => {
    const url = `${Compare.baseUrl}/get`;

    Compare.updateCounter();
    fetch(url)
      .then((res) => {
        if (res.ok) return res.json();
        throw new Error(res.statusText);
      })
      .then((res) => {
        Compare.compare = get(res, 'result.compares', []);
        Compare.updateCounter();
        window.Block.ProductControl?.updateControl();
      });
  };

  /***
   * Добавление товара
   * @param offerId{String} - id товара
   * @return {Promise<String>}
   */
  static add = ({ offerId }) => {
    const url = `${Compare.baseUrl}/add`;

    return fetch(url, {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({ offerId }),
    })
      .then((res) => {
        if (res.ok) return res.json();
        throw new Error(res.statusText);
      })
      .then((res) => {
        Compare.compare = get(res, 'result.compares', []);
        Compare.updateCounter();
        return offerId;
      });
  };

  /***
   * Удаление товаров из сравнения
   * @param offerId{String} - id товара
   * @param offerIds{String[]} - массив id
   * @return {Promise<String[]>} - возвращает id товаров
   */
  static remove = ({ offerId, offerIds }) => {
    const url = `${Compare.baseUrl}/remove`;

    return fetch(url, {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify({ offerId, offerIds }),
    })
      .then((res) => {
        if (res.ok) return res.json();
        throw new Error(res.statusText);
      })
      .then((res) => {
        Compare.compare = get(res, 'result.compares', []);
        Compare.updateCounter();
        return offerId ? offerId : offerIds;
      });
  };

  /***
   * Добавить товар или удалить товар
   * @param toggle{Boolean} - добавить/удалить
   * @param offerId{String} - id товара
   * @param offerIds{String[]} - массив id
   * @return {Promise<String>|Promise<String[]>}
   */
  static toggle = ({ toggle, offerId, offerIds }) => {
    if (toggle) return window.Block.Compare.add({ offerId, offerIds });
    else return window.Block.Compare.remove({ offerId, offerIds });
  };

  /***
   * Обновить счётчик товаров в избранном
   */
  static updateCounter = () => {
    const compareCounters = toArray(document.querySelectorAll('[data-counter-compare]'));
    const count = get(Compare, 'compare.length', 0);
    forEach(compareCounters, (counter) => {
      const max = counter.dataset['max'] || Infinity;
      counter.innerHTML = count > max ? `${max}+` : count;
      counter.classList.toggle('d-none', !count > 0);
    });
  };

  /***
   * Проверка есть ли товар в избранном
   * @param offerId{String} - id товара
   * @return {boolean}
   */
  static includes = ({ offerId }) => {
    const url = new URL(window.location.href);
    const query = url.searchParams.get('productList');
    return includes(window.Block.Compare.compare, offerId) || (!!query && query.includes(offerId));
  };

  /**
   * Установка данных сравнения
   * @param compare{Array} - массив сравнения
   * @param update{Boolean} - нужно ли обновлять контролы
   */
  static setData = ({ compare, update = true }) => {
    Compare.compare = compare;
    Compare.updateCounter();
    if (update) window.Block.ProductControl?.updateControl();
  };
}

if (NOT_PROD) Compare.init();

window.Block.Compare = Compare;
